import { graphql } from 'react-relay';

export const privacyPolicyChangeNoticeQuery = graphql`
    query privacyPolicyChangeNoticeQuery($userId: String!) {
        viewer {
            user(userId: $userId) {
                createdDate
            }
            regionalInfo {
                countryCode
            }
        }
    }
`;
